import { Extension } from '@flywheel-io/extension/lib/extension';
import {
  File,
  FileGetOptions,
} from '@flywheel-io/extension/lib/models/file.model';
import { Container } from '@flywheel-io/extension/lib/models/container.model';
import { PermissionAction, User } from '@flywheel-io/extension';
import { of } from 'rxjs';
import { DOMFile } from '@flywheel-io/extension/lib/data';
import { Channel } from '@flywheel-io/extension/lib/channel';

export function initMock(): Promise<Extension> {
  const file = {
    name: 'deid-profile.yaml',
    type: 'source code',
  } as File;
  const fileText = `
name: test-profile
dicom:
  fields:
  - name: AccessionNumber
    replace-with: XXXX
  - name: PatientName
    replace-with: XXXX
  - name: ReasonForStudy
    replace-with: XXXX
  `;
  const ext = new Extension();
  const mock = {
    container: {
      files: [
        { name: 'conflict.py' },
        { name: 'conflict.yaml' },
      ]
    } as Container,
    file: file,
    text: '',
    fileType: '',
    params: {},
    user: {} as User,
    channel: {} as Channel,
    handleMessage: () => { },
    waitForConnection: () => Promise.resolve({}),
    close: () => { },
    updateInfo: () => { },
    updateViewport: (viewport: { height?: number; width?: number }) => { },
    getContainer: (type: string, id: string) => Promise.resolve({}),
    getChildContainers: (parent: Container, type: string, query?: any) =>
      Promise.resolve({ current: [], total: 0 }),
    listContainers: (type: string, query?: any) => Promise.resolve([]),
    getFile: (fileId: string, options?: any) => Promise.resolve(null),
    getFileUrl: (file: File, options?: any) => Promise.resolve(''),
    getArchiveMembers: (container: Container, file: File) => Promise.resolve([]),
    executeDataView: (id: string, body: any) => Promise.resolve({}),
    updateContainerInfo: (container: Container, info: any) => Promise.resolve({}),
    updateFileInfo: (file: File, info: any) => Promise.resolve({}),
    readSetting: (id: string, settingKey: string) => Promise.resolve(settingKey),
    writeSetting: (id: string, settingKey: string, value: any) => Promise.resolve(null),
    addTag: (container: Container, tag: string) => Promise.resolve(null),
    removeTag: (container: Container, tag: string) => Promise.resolve(null),
    uploadFile: (container: Container, domfile: DOMFile, options?: any) =>
      of({
        type: 'response',
        file: {
          ...file,
          name: domfile.name,
        },
      }),
    uploadText: (text: string) => Promise.resolve(null),
    getFileBlob: (container: Container, file: File, options?: FileGetOptions) => {
      return Promise.resolve(new Blob([fileText.trim()], { type: 'text/yaml' }))
    },
    getFileText: (container: Container, file: File, options?: FileGetOptions) =>
      Promise.resolve(fileText.trim()),
    getContainerPermissions: (container: Container) =>
      Promise.resolve(new Set([PermissionAction.FilesCreateUpload])),
  };
  for (const key of Object.keys(mock) as (keyof typeof mock)[]) {
    (ext as any)[key] = mock[key];
  }
  return Promise.resolve(ext);
}
